export const environment = {
  production: true,
  apiUrl: 'https://businesscenterapiprod.azurewebsites.net',
  thisUrl: 'https://businesshub.lsretail.com',
  authenticationServiceUrl: 'https://authentication.lsretail.com',
  skipBcJobQueueCheck: false,
  allowBcSuperOrders: true,
  version: '00.10',
  googleAnalyticsId: 'G-QH9JH1X4S0',
  azureAdB2C: {
    authority: 'https://lsretailb2cprod.b2clogin.com/lsretailb2cprod.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN/v2.0',
    authWellknownEndpointUrl:
      'https://lsretailb2cprod.b2clogin.com/lsretailb2cprod.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN/v2.0/.well-known/openid-configuration',
    apiscope: 'https://lsretailb2cprod.onmicrosoft.com/03fdb392-ad32-4026-8c48-e1d64f86daf0/api',
    clientId: '293bc909-582c-4198-a288-1562eb22e646',
    bhclaim: 'Business Hub',
  },
};
